import { useCallback, useEffect, useState } from 'react';
import { useErrorHandling } from '../hooks/useErrorHandling';
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { buildService } from './service';
import serviceMethods from './service_methods';
const api = buildService('/companies/{id}/subsidiary_companies', {
  only: ['all', 'get']
});
const subsidiaryCompanyService = {
  useFetchAll: _ref => {
    let {
      setLoading,
      companyId,
      fetchImmediately = true
    } = _ref;
    const [subsidiaryCompanies, setSubsidiaryCompanies, fetchSubsidiaryCompanies] = serviceMethods.useFetch({
      callback: useCallback(async () => await api.all(companyId), [companyId]),
      setLoading,
      fetchImmediately
    });
    return [subsidiaryCompanies, setSubsidiaryCompanies, fetchSubsidiaryCompanies];
  },
  useFetchSubsidiaryCompany(companyId, subsidiaryCompanyId, setLoading) {
    const [subsidiaryCompany, setSubsidiaryCompany] = useState(null);
    const fetchSubsidiaryCompany = useErrorHandling(useCallback(async () => {
      setLoading && setLoading(true);
      const company = await subsidiaryCompanyService.get(companyId, subsidiaryCompanyId);
      setSubsidiaryCompany(company);
      setLoading && setLoading(false);
    }, [companyId, subsidiaryCompanyId, setLoading]), useCallback(async () => {
      setLoading && setLoading(false);
    }, [setLoading]));
    useEffect(() => {
      fetchSubsidiaryCompany();
    }, [fetchSubsidiaryCompany]);
    return [subsidiaryCompany, setSubsidiaryCompany];
  },
  useUpdateSubsidiaryCompany(companyId, setSubsidiaryCompany) {
    const updateSubsidiaryCompany = useErrorHandling(useCallback(async subsidiaryCompany => {
      const updatedCompany = await subsidiaryCompanyService.update(companyId, subsidiaryCompany);
      setSubsidiaryCompany && setSubsidiaryCompany(updatedCompany);
      return updatedCompany;
    }, [companyId, setSubsidiaryCompany]));
    return updateSubsidiaryCompany;
  },
  get(companyId, subsidiaryCompanyId) {
    return fetch(`/api/companies/${companyId}/subsidiary_companies/${subsidiaryCompanyId}`, {
      ...request.get
    });
  },
  update(companyId, subsidiaryCompany) {
    return fetch(`/api/companies/${companyId}/subsidiary_companies/${subsidiaryCompany.id}`, {
      ...request.put,
      body: JSON.stringify({
        subsidiary_company: subsidiaryCompany
      })
    });
  },
  all(companyId) {
    return fetch(`/api/companies/${companyId}/subsidiary_companies`, {
      ...request.get
    });
  },
  destroy(companyId, subsidiaryCompanyId) {
    return fetch(`/api/companies/${companyId}/subsidiary_companies/${subsidiaryCompanyId}`, {
      ...request.delete
    });
  },
  create(companyId, subsidiary_company) {
    return fetch(`/api/companies/${companyId}/subsidiary_companies`, {
      ...request.post,
      body: JSON.stringify({
        subsidiary_company
      })
    });
  }
};
export default subsidiaryCompanyService;